import React, { useState, useEffect } from "react";

import EditableText from "../../../../../../../../features/image-slider-new/components/inline-edit/EditableText";
import ChevronLeft from "../../../../../../../../features/cards-v2/components/actions/icons/ChevronLeft";
import ChevronRight from "../../../../../../../../features/cards-v2/components/actions/icons/ChevronRight";
import {
  SliderControlsContainer,
  SliderContainer,
  SliderArrowsGroup,
  SliderArrowContainer,
  SliderImagesContainer,
  SliderImage,
  SliderImageContentContainer,
  SliderImageContent,
  SliderImageHeading,
  SliderImageParagraph,
} from "./styles";
import { IMAGE_SLIDER_PROP } from "../../../../../settings/features/image-slider/defaults";
import { useImageSliderStore } from "../../../../../../../../stores/use-image-slider-store";
import { urlValidator } from "../../../../../../../../helpers/validators";

const SliderOne = ({ data, isPreview, canEdit, isView }) => {
  const { image: selectedImage, setImage } = useImageSliderStore((state) => ({
    image: state.image,
    setImage: state.setImage,
  }));
  const [position, setPosition] = useState(0);

  const nextSlide = () => {
    setPosition((prev) => (prev + 1) % data.images.length);
  };

  const previousSlide = () => {
    setPosition((prev) => (prev - 1 + data.images.length) % data.images.length);
  };

  const showContent = data.hasImagesTitle || data.hasImagesDescription;

  useEffect(() => {
    setPosition(0);
  }, [data?.images?.length]);

  return (
    <SliderContainer
      borderRadius={
        data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS][
          IMAGE_SLIDER_PROP.BORDER_RADIUS
        ]
      }
      isView={isView}
      isPreview={isPreview}
    >
      {!!data?.images?.length && (
        <SliderControlsContainer>
          <SliderArrowsGroup>
            <SliderArrowContainer onClick={previousSlide}>
              <ChevronLeft fillColor="#FFF" />
            </SliderArrowContainer>
            <SliderArrowContainer onClick={nextSlide}>
              <ChevronRight fillColor="#FFF" />
            </SliderArrowContainer>
          </SliderArrowsGroup>
        </SliderControlsContainer>
      )}

      <SliderImagesContainer position={position} isView={isView}>
        {data.images.map((image) => (
          <SliderImageContentContainer>
            <SliderImage
              src={image.link}
              alt={image?.title}
              position={image?.focalPoint}
              showPointer={image.linkToPage?.link || isPreview || canEdit}
              onClick={() => {
                if (isPreview) return;

                if (urlValidator({ url: image.linkToPage?.link }) && !canEdit) {
                  window.open(
                    image.linkToPage.link,
                    image.linkToPage.newTab ? "_blank" : "_top"
                  );
                }

                if (canEdit) {
                  if (image.id === selectedImage?.id) {
                    setImage(undefined);
                  } else setImage(image);
                }
              }}
            />

            {showContent && (
              <SliderImageContent
                textAlign={
                  data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS][
                    IMAGE_SLIDER_PROP.TEXT_ALIGNMENT
                  ]
                }
              >
                {data.hasImagesTitle && (
                  <SliderImageHeading>
                    {!(isPreview || isView) ? (
                      <EditableText
                        data={image}
                        field="title"
                        isEditable={canEdit}
                        customCalculatorStyles={{ minHeight: "1em" }}
                      />
                    ) : (
                      image.title
                    )}
                  </SliderImageHeading>
                )}
                {data.hasImagesDescription && (
                  <SliderImageParagraph>
                    {!(isPreview || isView) ? (
                      <EditableText
                        data={image}
                        field="description"
                        isEditable={canEdit}
                        customCalculatorStyles={{ minHeight: "1em" }}
                      />
                    ) : (
                      image.description
                    )}
                  </SliderImageParagraph>
                )}
              </SliderImageContent>
            )}
          </SliderImageContentContainer>
        ))}
      </SliderImagesContainer>
    </SliderContainer>
  );
};

export default SliderOne;
